import { computed, reactive } from 'vue'
import { createSharedComposable } from '@vueuse/core'

import { session } from '@/composables/useSession'
import { useEvent } from '@/composables/useEvent'

import { getActivitiesCount } from '@/modules/activity/api'
import type { ActivitiesCount } from '@/modules/activity/types'

const activitiesCount = reactive<{ state: ActivitiesCount; isLoaded: boolean }>({
  isLoaded: false,
  state: {
    total: 0,
    comments: {
      received: 0,
    },
    reviews: {
      received: 0,
    },
    feedback: {
      received: 0,
    },
    disputes: {
      all: 0,
      received: 0,
      started: 0,
    },
  },
})

export const activitiesCountState = computed(() => activitiesCount.state)

export const reloadActivitiesCount = () => {
  if (!session.workspace) return
  getActivitiesCount()
    .then((counts) => {
      activitiesCount.state.total = Number(counts.total) || 0
      activitiesCount.state.comments.received = Number(counts.comments?.received) || 0
      activitiesCount.state.reviews.received = Number(counts.reviews?.received) || 0
      activitiesCount.state.feedback.received = Number(counts.feedback?.received) || 0
      activitiesCount.state.disputes = {
        all: Number(counts.disputes?.all) || 0,
        received: Number(counts.disputes?.received) || 0,
        started: Number(counts.disputes?.started) || 0,
      }
    })
    .catch((err) => console.info(err))
}

export const useActivitiesCount = createSharedComposable(() => {
  if (!activitiesCount.isLoaded) {
    reloadActivitiesCount()

    activitiesCount.isLoaded = true
  }

  // Listen for refresh events to update counts when items are marked as seen
  // This will be registered once (shared composable) with proper cleanup via useEvent
  useEvent('refresh-activities-count', () => {
    reloadActivitiesCount()
  })

  return activitiesCountState
})
